import { useEffect, useState } from "react";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _OutputAuthorizationRequest, _RequestNeed, _single } from "../../../core/services/dataBean/EntityCatalog";
import { HandlerInfoProcess } from "../../bpm/config/InfoTramiteComponents/HandlerInfoProcess";
import { toast } from "react-toastify";
import useModal, { MODAL_LG, MODAL_md, MODAL_XL } from "../../theme/Component/hooks/useModal";
import { OutputAuthorizationItem } from "./OutputAuthorizationItem/OutputAuthorizationItem";
import usePaginator from "../../theme/Component/usePaginator";
import { VisorAnyDocument } from "../../documents/VisorAnyDocument";
import { Alert } from "../../theme/Component/Alert";

interface OutputAutorizationProps {
    _IDEmployee?: number
}

export const OutputAuthorizationRequest = ({ _IDEmployee }: OutputAutorizationProps) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_OutputAuthorizationRequest);
    const paginador = usePaginator();

    const [doc, setDoc] = useState<any>({});

    const modalHistory = useModal("Historial del procedimiento", MODAL_XL)
    const modal = useModal("Productos/Activos Solicitados", MODAL_LG);
    const modalDoc = useModal("Documento de Salida", MODAL_XL);

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const renderUserInfo = (item: any) => {
        let render =
            ` 
        <div>            
            <strong>NIT: </strong><small>${item.EmployeeNit ? item.EmployeeNit : 'NA'}</small><br />
            <strong>Usuario: </strong><small>${item.EmployeeFullName ? item.EmployeeFullName : 'NA'}</small><br />            
            <strong>Area del Solicitante: </strong><small>${item.FunctionalIDLn ? `${item.FunctionalAreaJsonCode ?? ""} - ${item.FunctionalAreaName ?? ""}` : 'NA'}</small><br />            
            <strong>Oficina: </strong><small>${item.OfficeName ? item.OfficeName : 'NA'}</small><br />            
        </div>
        `
        return render;
    }

    const getLista = () => {

        const props: any = {
            IDEmployee: _IDEmployee ?? null
        }

        instance.getOutputAuthorizationRequestRender(paginador.page, 15, props).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                paginador.setRegiPerPage(15)

                resp.List.forEach((element: any) => {
                    const data = element.DataBeanProperties;
                    data.TimeInfo = `Desde: ${data.FromDate ? data.FromDate.slice(0, 10) : "N/P"} - Hasta: ${data.UptoDate ? data.UptoDate.slice(0, 10) : "N/P"}`;
                    data.UserRenderInfo = renderUserInfo(data)
                });

                setLista(resp.List);
            }
        ).catch(() => {
            toast.error("Error al cargar la lista de Solicitudes");
        });
    };

    const getPDFDocument = () => {
        instance.getPdfSalidaAlmacen(_single.getAccountID(), bean.IDOutputAuthorizationRequest).then(
            (resp) => {
                setDoc(resp)
                modalDoc.open()
            }
        ).catch(err => { toast.error(err) })
    }

    const head = [
        { title: 'ID', property: 'IDOutputAuthorizationRequest', visible: true },
        { title: 'Solicitud', property: 'Description', visible: true },
        { title: 'Solicitante', property: 'UserRenderInfo', visible: true, Style: { minWidth: "250px" } },
        { title: 'Estado de la Solicitud', property: 'StateName', visible: true },
        { title: 'Lapzo de Tiempo', property: 'TimeInfo', visible: true, Style: { minWidth: "200px" } },
        { title: 'Procedimiento Asociado', property: 'ProcedureAlphaCode', visible: true },
        { title: 'Estado del Procedimiento', property: 'StateImpName', visible: true },
        { title: 'Fecha de Soliciud', property: 'Since', visible: true },
    ];

    const listaBotones = () => {
        const botones = [
            { titulo: 'Activos/Productos Solicitados', icono: 'ri-list-check', visible: true, evento: () => { modal.open(); } },
            { titulo: 'Ver Documento', icono: 'ri-article-line', visible: true, evento: () => { getPDFDocument(); } },
            { titulo: 'Historico', icono: 'ri-edit-2-line', visible: true, evento: () => { modalHistory.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Lista de Solicitudes">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} records={paginador} />

                    <Modal modal={modalHistory.modal} updateModal={modalHistory.setModal} >
                        <HandlerInfoProcess _ProcedureIMPID={bean.IDProcedureIMP} />
                    </Modal>

                    <Modal modal={modal.modal} updateModal={modal.setModal} >
                        <OutputAuthorizationItem _OutputAutorization={bean} />
                    </Modal>

                    <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal} >
                        <div className="row">
                            <div className="col-md-12">
                                {doc.TypeName ?
                                    <VisorAnyDocument url={doc.URL} type={doc.TypeName} />
                                    :
                                    <Alert clase="info" children={`No se genero el documento Correctamente`} />
                                }
                            </div>
                        </div>
                    </Modal>

                </div>
            </div>
        </BasicPage>
    )

}